import useClickOutside from "@admin/hooks/useClickOutside";
import { isBefore, isSameDay, startOfDay, startOfToday } from "date-fns";
import { useCallback, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { DayMenu } from "./DayMenu";

interface DayProps {
  date?: Date;
  setSelectedDay: React.Dispatch<React.SetStateAction<Date>>;
  setAddModal: React.Dispatch<React.SetStateAction<boolean>>;
  setAddOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  setCopyShiftsDayModal: React.Dispatch<React.SetStateAction<boolean>>;
  setClearDayShiftsModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export function Day({
  date,
  setAddModal,
  setSelectedDay,
  setAddOpenModal,
  setCopyShiftsDayModal,
  setClearDayShiftsModal,
}: DayProps) {
  const [dayMenu, setDayMenu] = useState(false);

  const { i18n } = useTranslation();

  const ref = useRef<HTMLDivElement>(null);

  const onClickDot = useCallback(() => {
    setDayMenu((prev) => !prev);

    setSelectedDay(date ?? new Date());
  }, [date, setSelectedDay]);

  const isPast = useMemo(() => {
    if (date) {
      if (isSameDay(startOfDay(date), startOfToday())) {
        return false;
      }

      return isBefore(startOfDay(date), startOfToday());
    }
    return false;
  }, [date]);

  const isSame = useMemo(() => isSameDay(date ?? "", startOfToday()), [date]);

  useClickOutside(ref, () => setDayMenu(false));

  return (
    <div ref={ref}>
      <div
        className={`flex  flex-row justify-between items-center ${isPast || isSame ? "pointer-events-none" : ""} `}
      >
        <span className="mx-auto">
          {date &&
            Intl.DateTimeFormat(i18n.language, {
              day: "numeric",
              month: "short",
              weekday: "long",
            }).format(date)}
        </span>
        <i
          onClick={onClickDot}
          className="ki-filled ki-dots-vertical text-lg cursor-pointer ml-auto"
        ></i>
      </div>
      {dayMenu && (
        <DayMenu
          setAddModal={setAddModal}
          setAddOpenModal={setAddOpenModal}
          setCopyShiftsDayModal={setCopyShiftsDayModal}
          setClearDayShiftsModal={setClearDayShiftsModal}
        />
      )}
    </div>
  );
}
